import React from 'react';
import { Link } from 'react-router-dom';

import './post.styles.scss';

function htmlDecode (input) {
    return input.replace(/&#8217;/g, "’")
                .replace(/&#8216;/g, "‘")
                .replace(/&#8220;/g, "“")
                .replace(/&#8221;/g, "”")
                .replace(/&amp;/g, "&")
}

export const Post = ({image, title, url}) => (
    <li>
        <Link to={`/tourism-community-stories/${url}`}>
            <div className="content-wrapper">
                <img src={image} alt={htmlDecode(title)}/>
                <h3>{htmlDecode(title)}</h3>
            </div>
            <p>Read More<span className="link-angle">&#8250;</span></p>
        </Link>
    </li>
)